module.exports = __webpack_public_path__ + "img/symbol_4.36cb27c3.png";